export const telecommunicationsContent = {
    id: "telecommunications",
    route: "/telekomunikace",
    menuTitle: "Telekomunikace",
    title: "Telekomunikace a konektivita",
    headline: "Spolehlivé spojení pro průmysl, energetiku a veřejnou správu",
    lead: "Zajišťujeme konektivitu a vzdálený monitoring pro provozy, veřejnou správu a technickou infrastrukturu.",
    summary: "Služby pokrývají záložní internet, Starlink, privátní LTE/5G, optické sítě, IoT komunikaci, kamerové systémy a vzdálený monitoring.",
    primaryItems: [
        "Starlink instalace",
        "záložní internetové připojení",
        "privátní LTE a 5G",
        "optické sítě",
        "WiFi infrastruktura",
        "IoT komunikace",
        "kamerové systémy",
        "vzdálený monitoring"
    ],
    sections: [
        {
            title: "Služby",
            items: [
                "Starlink instalace",
                "záložní internetové připojení",
                "privátní LTE a 5G",
                "optické sítě",
                "WiFi infrastruktura",
                "IoT komunikace",
                "kamerové systémy",
                "vzdálený monitoring"
            ]
        }
    ]
};
